"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineTitle = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineTitle = (item) => {
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return null;
    switch (item.type) {
        case "GOLF": {
            const config = latest_version.config;
            return `Golf at ${config?.course?.name?.en}`;
        }
        case "HOTEL": {
            const config = latest_version.config;
            return `${config.where_when_who.number_of_nights} Nights at ${config.where_when_who.hotel_name}`;
        }
        case "TRANSFER": {
            const config = latest_version.config;
            switch (config.where_when_who.type) {
                case "ONE_WAY":
                    return `One Way Transfer: ${config?.transfer_legs?.outbound?.from_name} > ${config?.transfer_legs?.outbound?.to_name}`;
                case "RETURN":
                    return `Return Transfer: ${config?.transfer_legs?.outbound?.from_name} > ${config?.transfer_legs?.outbound?.to_name} `;
                case "CUSTOM":
                    return `Custom Transfer: ${config?.transfer_legs?.outbound?.from_name} > ${config?.transfer_legs?.outbound?.to_name} > ${config?.transfer_legs?.inbound?.to_name}`;
            }
            return "";
        }
        case "CUSTOM": {
            const config = latest_version.config;
            return config.where_when_who.description;
        }
    }
};
exports.getOrderLineTitle = getOrderLineTitle;
